import { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { Loader2, Mail, Lock, ArrowLeft, Building2 } from 'lucide-react';
import { useAuth, formatApiErrorDetail } from '../context/AuthContext';

export default function AnuncianteEntrar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginAnunciante } = useAuth();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErro(''); setLoading(true);
    try {
      await loginAnunciante(email, senha);
      navigate(location.state?.from || '/anunciante/dashboard');
    } catch (err) {
      setErro(formatApiErrorDetail(err?.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Link to="/" className="flex items-center gap-2 px-4 py-4 text-sm text-gray-600 hover:text-[#1D9E75]">
        <ArrowLeft size={15} /> Voltar
      </Link>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-sm bg-white rounded-2xl shadow-sm p-8">
          <div className="mb-6 flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-[#E1F5EE] flex items-center justify-center text-[#1D9E75]">
              <Building2 size={18} />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Work Sans', sans-serif" }}>Anunciante</h1>
              <p className="text-xs text-gray-500">Acesse seu painel</p>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1">Email</label>
              <div className="relative">
                <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="anunc-login-email-input"
                  className="w-full border border-gray-200 rounded-xl px-3 py-2.5 pl-9 text-sm focus:outline-none focus:ring-2 focus:ring-[#1D9E75]" />
              </div>
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1">Senha</label>
              <div className="relative">
                <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input type="password" required value={senha} onChange={(e) => setSenha(e.target.value)} data-testid="anunc-login-senha-input"
                  className="w-full border border-gray-200 rounded-xl px-3 py-2.5 pl-9 text-sm focus:outline-none focus:ring-2 focus:ring-[#1D9E75]" />
              </div>
            </div>

            {erro && <div className="bg-red-50 border border-red-200 text-red-700 text-xs rounded-lg px-3 py-2">{erro}</div>}

            <button type="submit" disabled={loading} data-testid="anunc-login-submit-btn"
              className="w-full bg-[#1D9E75] hover:bg-[#178460] text-white font-medium rounded-xl py-2.5 transition-colors disabled:opacity-50 flex items-center justify-center gap-2">
              {loading && <Loader2 size={14} className="animate-spin" />} Entrar
            </button>
          </form>

          <p className="text-center text-xs text-gray-500 mt-6">
            Ainda não anuncia conosco?{' '}
            <Link to="/anunciante/cadastro" className="text-[#1D9E75] font-semibold hover:underline">Criar conta grátis</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
